module.exports = __webpack_public_path__ + "fa-solid-900.0ab54153eeeca0ce0397.woff2";


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/src/assets/plugins/FontAweson/webfonts/fa-solid-900.woff2
// module id = ../../../../../src/assets/plugins/FontAweson/webfonts/fa-solid-900.woff2
// module chunks = styles